import Vue from 'vue'
import App from './App.vue'
/* 路由 */
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Element)
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

import {
	BootstrapVue
} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import 'jquery/dist/jquery.min'
// import '@/assets/styles/bootstrap.min.css'
import '@/assets/styles/index.scss' // global css

import '@/assets/css/style.css'
import '@/assets/css/responsive.css'
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)
import VClamp from 'vue-clamp'
Vue.component('VClamp', VClamp)

/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next();
});

new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})